import { merge } from 'lodash';

import memoizePromise from '../../01-helpers/utilities/memoize-promise';
import { post } from '../../01-helpers/services/ajax';

/* ========================================================================== */

const defaultParams = {};


export default memoizePromise(data => new Promise((resolve, reject) => {
    post(
	    '/api/teetimes/getteetimes',
        {
            // add data to api call
			data: merge({}, defaultParams, data)
        }
    ).done(data => resolve(data)).fail(reject);
}));
